// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer-interval {
    position: relative;
    padding: 3px 5px;
    box-sizing: border-box;
    border-left: 1px solid #6E7079;
}

.timer-interval-icon {
    padding-left: 5px;
    border-left: 1px solid #6E7079;
    margin-left: 5px;
}

    .timer-interval-icon::before {
        width: 30px;
        height: 30px;
        content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }

.icon-dropdown {
    margin-left: 20px;
}
.icon-dropdown path {
    fill: var(--text-color);
}

.icon-arrow{
    fill: var(--text-color);
    cursor: pointer;
}

.time-interval-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 12px;
}

.timer-interval {
    white-space: nowrap;
    box-sizing: border-box;
    border: 1px solid #6E7079;
    background: rgb(191, 191, 191);
    display: flex;
    align-items: center;
    font-size: 12px;
}

.interval-dropdown-label {
    white-space: nowrap;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid;
    border-color: var(--text-color);
    padding: 3px 20px;
    font-size: 12px;
    cursor: pointer;
}
.timeinterval-label{
    color: var(--text-color);
}

.interval-dropdown-list {
    background: #fff;
}

.dropdown-list {
    width: 100%;
    background: #fff;
    border: 1px solid;
    max-height: 200px;
    overflow-y: scroll;
}

    .dropdown-list li {
        font-size: 12px;
        padding: 5px;
        cursor: pointer;
    }

        .dropdown-list li:hover {
            background: #1E90FF;
            color: #ffff;
        }

.interval-controller {
    display: flex;
    align-items: center;
}

    .interval-controller > div {
        cursor: pointer;
    }

.timeinterval-back {
    margin: 0 10px;
}

.timeinterval-forward {
    margin: 0 10px;
}

.float-container {
    position: absolute;
    min-width: 130px;
    left: calc(100% + 1px);
}

.tree-control-wrap input {
    width: 100%;
    padding: 5px 10px;
    outline: none;
    border-radius: 0;
    background: #D0D0D0;
    border: none;
    border-bottom: 1px solid #000;
    box-sizing: border-box;
    font-size: 12px;
    cursor: pointer;
}

.tree-control-wrap select {
    padding: 5px 10px;
    width: 100%;
    border: 1px solid #000;
    border-left: none;
    border-right: none;
    box-sizing: border-box;
    font-size: 12px;
    cursor: pointer;
}

.tree-control-wrap > div {
    padding: 5px 10px;
    width: 100%;
    color: #fff;
    background: #1E90FF;
    text-align: center;
    box-sizing: border-box;
    font-size: 12px;
    cursor: pointer;
}

.dropdown-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    margin: 0;
    padding: 7px 0;
    background: transparent;
    box-sizing: border-box;
    pointer-events: none;
    display: none;
}

    .dropdown-btn.active {
        pointer-events: all;
        display: block;
    }

    .dropdown-btn:hover {
        background: #1E90FF;
    }

        .dropdown-btn:hover svg {
            fill: #fff;
        }

    .dropdown-btn svg {
        width: 10px;
        height: 10px;
    }

.dropdown-down-btn {
    bottom: 0;
}

.dropdown-up-btn {
    top: 0;
}

    .dropdown-up-btn svg {
        transform: rotateZ(90deg);
    }

.dropdown-down-btn svg {
    transform: rotateZ(-90deg);
}

.hidden {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}

.time-element {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.icon-rotate {
    transform: rotate(-90deg);
}

.timeinterval-select {
    position: relative;
}

/* ::-webkit-scrollbar {
    width: 12px;
} */
`, "",{"version":3,"sources":["webpack://./src/controls/trend/timeinterval.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;AACpB;;IAEI;QACI,WAAW;QACX,YAAY;QACZ,gDAAqC;IACzC;;AAEJ;IACI,iBAAiB;AACrB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;IAEI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;;QAEI;YACI,mBAAmB;YACnB,YAAY;QAChB;;AAER;IACI,aAAa;IACb,mBAAmB;AACvB;;IAEI;QACI,eAAe;IACnB;;AAEJ;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;AACjB;;IAEI;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;QAEI;YACI,UAAU;QACd;;IAEJ;QACI,WAAW;QACX,YAAY;IAChB;;AAEJ;IACI,SAAS;AACb;;AAEA;IACI,MAAM;AACV;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;GAEG","sourcesContent":[".timer-interval {\r\n    position: relative;\r\n    padding: 3px 5px;\r\n    box-sizing: border-box;\r\n    border-left: 1px solid #6E7079;\r\n}\r\n\r\n.timer-interval-icon {\r\n    padding-left: 5px;\r\n    border-left: 1px solid #6E7079;\r\n    margin-left: 5px;\r\n}\r\n\r\n    .timer-interval-icon::before {\r\n        width: 30px;\r\n        height: 30px;\r\n        content: url('./assets/calendar.svg');\r\n    }\r\n\r\n.icon-dropdown {\r\n    margin-left: 20px;\r\n}\r\n.icon-dropdown path {\r\n    fill: var(--text-color);\r\n}\r\n\r\n.icon-arrow{\r\n    fill: var(--text-color);\r\n    cursor: pointer;\r\n}\r\n\r\n.time-interval-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    margin-top: 12px;\r\n}\r\n\r\n.timer-interval {\r\n    white-space: nowrap;\r\n    box-sizing: border-box;\r\n    border: 1px solid #6E7079;\r\n    background: rgb(191, 191, 191);\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 12px;\r\n}\r\n\r\n.interval-dropdown-label {\r\n    white-space: nowrap;\r\n    display: flex;\r\n    align-items: center;\r\n    box-sizing: border-box;\r\n    border: 1px solid;\r\n    border-color: var(--text-color);\r\n    padding: 3px 20px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n.timeinterval-label{\r\n    color: var(--text-color);\r\n}\r\n\r\n.interval-dropdown-list {\r\n    background: #fff;\r\n}\r\n\r\n.dropdown-list {\r\n    width: 100%;\r\n    background: #fff;\r\n    border: 1px solid;\r\n    max-height: 200px;\r\n    overflow-y: scroll;\r\n}\r\n\r\n    .dropdown-list li {\r\n        font-size: 12px;\r\n        padding: 5px;\r\n        cursor: pointer;\r\n    }\r\n\r\n        .dropdown-list li:hover {\r\n            background: #1E90FF;\r\n            color: #ffff;\r\n        }\r\n\r\n.interval-controller {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n    .interval-controller > div {\r\n        cursor: pointer;\r\n    }\r\n\r\n.timeinterval-back {\r\n    margin: 0 10px;\r\n}\r\n\r\n.timeinterval-forward {\r\n    margin: 0 10px;\r\n}\r\n\r\n.float-container {\r\n    position: absolute;\r\n    min-width: 130px;\r\n    left: calc(100% + 1px);\r\n}\r\n\r\n.tree-control-wrap input {\r\n    width: 100%;\r\n    padding: 5px 10px;\r\n    outline: none;\r\n    border-radius: 0;\r\n    background: #D0D0D0;\r\n    border: none;\r\n    border-bottom: 1px solid #000;\r\n    box-sizing: border-box;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n\r\n.tree-control-wrap select {\r\n    padding: 5px 10px;\r\n    width: 100%;\r\n    border: 1px solid #000;\r\n    border-left: none;\r\n    border-right: none;\r\n    box-sizing: border-box;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n\r\n.tree-control-wrap > div {\r\n    padding: 5px 10px;\r\n    width: 100%;\r\n    color: #fff;\r\n    background: #1E90FF;\r\n    text-align: center;\r\n    box-sizing: border-box;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n\r\n.dropdown-btn {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    left: 0;\r\n    margin: 0;\r\n    padding: 7px 0;\r\n    background: transparent;\r\n    box-sizing: border-box;\r\n    pointer-events: none;\r\n    display: none;\r\n}\r\n\r\n    .dropdown-btn.active {\r\n        pointer-events: all;\r\n        display: block;\r\n    }\r\n\r\n    .dropdown-btn:hover {\r\n        background: #1E90FF;\r\n    }\r\n\r\n        .dropdown-btn:hover svg {\r\n            fill: #fff;\r\n        }\r\n\r\n    .dropdown-btn svg {\r\n        width: 10px;\r\n        height: 10px;\r\n    }\r\n\r\n.dropdown-down-btn {\r\n    bottom: 0;\r\n}\r\n\r\n.dropdown-up-btn {\r\n    top: 0;\r\n}\r\n\r\n    .dropdown-up-btn svg {\r\n        transform: rotateZ(90deg);\r\n    }\r\n\r\n.dropdown-down-btn svg {\r\n    transform: rotateZ(-90deg);\r\n}\r\n\r\n.hidden {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.time-element {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.icon-rotate {\r\n    transform: rotate(-90deg);\r\n}\r\n\r\n.timeinterval-select {\r\n    position: relative;\r\n}\r\n\r\n/* ::-webkit-scrollbar {\r\n    width: 12px;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
